<template>
  <button
    class="mik-mak-button btn btn--primary"
    :class="cssClass"
    :data-mm-sticky="sticky"
    :data-mm-wtbid="wtbId"
    :data-mm-ids="product.id"
    :data-mm-default-id="product.id"
    v-bind="additionalProperties"
    @click="pushTaggingEvent"
  >
    {{ label }}
  </button>
</template>

<script>
  import { AnalyticsHandler } from '@Foundation/analyticsHandler';

  export default {
    name: 'MikMak',
    props: {
      wtbId: { type: String, required: true },
      product: { type: Object, required: true },
      label: { type: String, required: false, default: 'Buy Now' },
      sticky: { type: Boolean, default: false },
      productIdType: { type: String, required: false, default: null },
      isPdp: { type: Boolean, default: false },
      cssClass: { type: String, default: '' },
    },
    computed: {
      additionalProperties() {
        if (!this.productIdType) {
          return {};
        }

        return {
          'data-mm-id-type': this.productIdType,
        };
      },
    },
    mounted() {
      const urlParams = new URLSearchParams(window.location.search);
      const buyParam = urlParams.get('buy');
      this.checkIfMikMakIsLoaded(() => {
        this.registerMikMakCallback();
        if (window.aweLoader.isOpen()) return;
        if (buyParam === 'true' && this.isPdp) {
          document.querySelector('.mik-mak-button').click();
        }
      });
    },
    beforeDestroy() {
      if (
        window.swnDataLayer &&
        window.swnDataLayer._widget_callbacks_map &&
        this.product &&
        this.product.id
      ) {
        const normalizedId = this.normalizeProductId(this.product.id);
        if (window.swnDataLayer._widget_callbacks_map[normalizedId]) {
          delete window.swnDataLayer._widget_callbacks_map[normalizedId];
          window.swnDataLayer._widget_callbacks = Object.values(
            window.swnDataLayer._widget_callbacks_map
          );
        }
      }
    },
    methods: {
      normalizeProductId(id) {
        return id ? String(id).replace(/^0+/, '') : '';
      },

      registerMikMakCallback() {
        if (!window.swnDataLayer._widget_callbacks) {
          window.swnDataLayer._widget_callbacks = [];
          window.swnDataLayer._widget_callbacks_map = {};
          window.swnDataLayer.widget_callback = event => {
            for (const callback of window.swnDataLayer._widget_callbacks) {
              callback(event);
            }
          };
        }
        if (this.product && this.product.id) {
          const normalizedId = this.normalizeProductId(this.product.id);
          if (!window.swnDataLayer._widget_callbacks_map[normalizedId]) {
            const boundCallback = this.handleMikMakEvents.bind(this);
            window.swnDataLayer._widget_callbacks_map[normalizedId] = boundCallback;
            window.swnDataLayer._widget_callbacks = Object.values(
              window.swnDataLayer._widget_callbacks_map
            );
          }
        }
      },

      pushTaggingEvent() {
        AnalyticsHandler.pushDataLayer({
          event: 'uaevent',
          ecommerce: 'undefined',
          eventCategory: 'ecommerce',
          eventAction: 'click to buy',
          eventLabel: `${this.product.name}::${this.product.id}`,
          event_name: 'buy_now',
          product_info: `${this.product.name}::${this.product.id}`,
        });
      },

      handleMikMakEvents(event) {
        if (event.action === 'buy') {
          const normalizedEventId = this.normalizeProductId(event.product.ean);
          const normalizedProductId = this.normalizeProductId(this.product.id);
          if (event.product.ean !== this.product.id && normalizedEventId !== normalizedProductId) {
            return;
          }

          const productInfo = `${event.product.name}::${event.product.ean}`;
          const storeName = event.store.name;
          const vtoClicked = sessionStorage.getItem('vtoClicked');
          const urlParams = new URLSearchParams(window.location.search);
          const locationParams = urlParams.get('location');
          const redirectFromVto = locationParams === 'virtual-try-on';

          AnalyticsHandler.pushDataLayer({
            event: 'addToCart',
            event_name: 'add_to_cart',
            eventCategory: 'ecommerce',
            eventAction: `redirection::${storeName}`,
            eventLabel: productInfo,
            product_info: productInfo,
            step: 'redirection',
            store_name: storeName,
            ecommerce: {
              currencyCode: 'USD',
              add: {
                products: [
                  {
                    name: this.product.name,
                    id: this.product.id,
                    price: this.product.price,
                    brand: this.product.brand,
                    category: this.product.category,
                    variant: this.product.variant,
                    quantity: 1,
                    list: this.product.list,
                    metric52: this.product.metric52,
                    position: this.product.position,
                    dimension35: this.product.dimension35,
                    dimension36: this.product.dimension36,
                    dimension39: this.product.dimension39,
                    dimension48: this.product.dimension48,
                    dimension49: vtoClicked || redirectFromVto ? 'activated' : this.product.dimension49,
                    dimension59: this.product.dimension59,
                    dimension153: this.product.dimension153,
                    dimension154: this.product.dimension154,
                  },
                ],
              },
            }
          });
        }
      },

      checkIfMikMakIsLoaded(method) {
        let counter = 0;
        const maxChecks = 10;
        return new Promise((resolve, reject) => {
          const checkInterval = setInterval(() => {
            if (window.aweLoader) {
              clearInterval(checkInterval);
              method();
              resolve();
            } else if (counter >= maxChecks) {
              clearInterval(checkInterval);
              reject(new Error('Maximum number of checks reached'));
            }
            counter++;
          }, 1000);
        });
      },
    },
  };
</script>
